<template> </template>

<script>
export default {
  mounted () {
    this.$router.replace({ path: '/single/standard/' })
  }
}
</script>

<style></style>
